module.exports = __webpack_public_path__ + "static/media/video_3.5518767.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/views/help/videos/video_3.mp4
// module id = Gf6M
// module chunks = 0